// extracted by mini-css-extract-plugin
export var sm = "768";
export var md = "1024";
export var lg = "1280";
export var xl = "1600";
export var element = "Button-module--element--v8iCZ";
export var buttonText = "Button-module--buttonText---8dlh";
export var large = "Button-module--large--tNKXt";
export var withIcon = "Button-module--withIcon--XJulW";
export var iconLeft = "Button-module--iconLeft--MaY77";
export var small = "Button-module--small--dI6As";
export var primary = "Button-module--primary--q6jBK";
export var secondary = "Button-module--secondary--82MON";